import * as React from 'react';

const SvgExpandOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M6 12V6h6V4H4v8h2ZM18 12v6h-6v2h8v-8h-2Z", fill: "currentColor" })));

export { SvgExpandOutline as default };
